import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { productionDayApi } from '../api/productionDay.api';

const keys = {
  config: (depId) => ['deployment', depId, 'production-day'],
};

export function useProductionDay(depId) {
  return useQuery({
    queryKey: keys.config(depId),
    queryFn:  () => productionDayApi.get(depId),
    enabled:  !!depId,
    staleTime: 60_000,
  });
}

export function useSetProductionDay(depId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => productionDayApi.set(depId, payload),
    onSuccess:  () => qc.invalidateQueries({ queryKey: keys.config(depId) }),
  });
}

export function useClearProductionDay(depId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => productionDayApi.clear(depId),
    onSuccess:  () => qc.invalidateQueries({ queryKey: keys.config(depId) }),
  });
}
